var tw = tw || {};
tw.Whereinwisco = (function () {
    var _log = false,
        maxQuestions = 6,//6 for production
        questions = [],
        questionCurrentIndex = 0,
        correctAnswers = 0,
        resultsMessages = [],
        responseCorrect = [],
        responseIncorrect = [],
        holdData = null,
        isValid = false,
        errorMsg = "";

    if (_log) console.log('init.tw.whereinwisco.js');

	/**
	 * Classes
	 */
    var Question = function (obj) {
        this.description = obj.description;
        this.url = obj.url;
        this.image = obj.image;
        this.location = obj.location;
        var tempAnswers = obj.answers;
        //console.log('tempAnswers: ', tempAnswers);
        this.answers = shuffleArray(tempAnswers);
        for(var i = 0; i < this.answers.length; i ++) {
            var curAnswer = new Answer(this.answers[i]);
            if(curAnswer.correct) {
                this.answer = i;
            }
        }
        //console.log('new Question:', this);
    };

    var Answer = function (obj) {
        this.title = obj.title;
        this.correct = obj.correct;
        //console.log('new Answer:', this);
    };


    //TEMPLATES
    var progressTemplate = $('#progressTemplate').html(),
        questionTemplate = $('#questionTemplate').html();




	/**
	 * Initialize page
	 */
    var initializePage = function () {
        if (_log) console.log('initializePage()');

        $('.js-quiz-play-now').on('click', function () {
            //console.log("js-quiz-play-now");
            $('.js-quiz-intro').addClass('hidden');
            loadQuestion(questionCurrentIndex);
        });

        $('body').on('click', '.js-quiz-answer', function () {
            //console.log('.js-quiz-answer-fiction.click');
            var correctAnswer = $(this).closest('.js-quiz-fest').attr('data-correctanswer'),
                thisAnswer = $(this).attr('data-answer');

            checkAnswer(thisAnswer, correctAnswer);
        });

        $('body').on('click', '.js-quiz-next-question', function () {
            //console.log('.js-quiz-next-question.click');
            if (_log) console.log('questionCurrentIndex', questionCurrentIndex, ' of ', maxQuestions);
            if (questionCurrentIndex < maxQuestions - 1) {
                questionCurrentIndex++;
                loadQuestion(questionCurrentIndex);
            } else {
                if (_log) console.log('show results');
                showResults();
            }
        });

        $('body').on('click', '.js-quiz-form-submit', function () {
            //if (_log) console.log("click share");
            postToForm($(this));
        });

        $('body').on('click', '.js-extlink', function () {
            //if (_log) console.log('ext link');
            var extName = $(this).text();
            tw.Analytics.ga4('Where In Wisco', 'Location Link', extName);
        });

        $('body').on('click', '.social-overlay__content--icons a', function () {
            //if (_log) console.log('social share');
            tw.Analytics.ga4('Where In Wisco', 'Share', '');
        });

        $('body').on('click', '.js-quiz-play-again', function () {
            //console.log('.js-quiz-play-again.click');
            $('.js-form-content').removeClass('hidden');
            $('.js-form-thankyou').addClass('hidden');
            reloadQuestions();
        });

        getContent();
    };


    var validateForm = function () {

        isValid = true;
        //var phoneRegex = "^\\(?([0-9]{3})\\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$";
        var emailRegex = "^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$";

        errorMsg = "";

        if (!$('#Email').val().match(emailRegex)) {
            isValid = false;
            errorMsg = "Please enter a valid email."
        }
        // else if ($('#FirstName').val() == "") {
        //     isValid = false;
        //     errorMsg = "Please enter a Name."
        // }
        // else if (!$('#Phone').val().match(phoneRegex)) {
        // 	isValid = false;
        // 	errorMsg = "Please enter a valid 10 digit phone number."
        // }
        // else if (!$('#Agreed').is(":checked")) {
        // 	isValid = false;
        // 	errorMsg = "You must be 18 to enter."
        // }

        if (_log) console.log('isValid: ', isValid, errorMsg);
    };


	/**
	 * Submit Share by Email form
	 * @param {*} button 
	 */
    var postToForm = function (button) {
        validateForm();
        var form = button.parents("form");
        if (_log) console.log('form:', $(form).serialize());
        if (isValid) {
            $('.js-quiz-error-message').addClass('hidden');

            $.ajax({
                type: "POST",
                url: '/sweepstakes/submitsweepstakesshortform?sweepstakesType=WhereInWisco',
                data: $(form).serialize(),
                success: function (data) {
                    if (_log) console.log('shareByEmail.success.data:', data);
                    $('.js-form-content').addClass('hidden');
                    $('.js-form-thankyou').removeClass('hidden');

                },
                error: function (xhr, status, err) {
                    console.error(xhr, status, err);
                    alert("Sorry! Your submission cannot be processed at this time.");
                }
            });

        }
        else {
            $('.js-quiz-error-message').html(errorMsg);
            $('.js-quiz-error-message').removeClass('hidden');
        }
    };

	/**
	 * Get content from local json
	 */
    var getContent = function () {
        var dataPath = '/JS/tw/quiz/whereinwisco/data.json';
        if (_log) console.log('getContent()', dataPath);
        var jqxhr = $.getJSON(dataPath, function (data) {
            if (_log) console.log("getContent.data:", data);

            holdData = data;//hold this data to shuffle and reload later
            resultsMessages = data.resultsMessages;
            responseCorrect = data.responses.correct;
            responseIncorrect = data.responses.incorrect;
            // if (_log) console.log('responseCorrect', responseCorrect);
            // if (_log) console.log('responseIncorrect', responseIncorrect);
            $('.js-quiz-version').html(data.version);
            processContent(data);
        })
        .fail(function (err) {
            console.error("error:", err);
        });
    };



	/**
	 * Process content from JSON file, Shuffle, trim array
	 * @param {*} data 
	 */
    var processContent = function (data) {
        if (_log) console.log('processContent()', data);

        var tempArr = shuffleArray(data.questions);//randomize questions
        var compiledTemplate = Template7.compile(progressTemplate);
        var html = '<span class="progress-blocks__label">Progress</span>';
        questions = [];

        for (var i = 0; i < maxQuestions; i++) {
            var question = new Question(tempArr[i]);
            //console.log('question', question);
            questions.push(question);

            var jsonContent = {
                id: i
            };
            //if (_log) console.log('jsonContent:', jsonContent);
            html += compiledTemplate(jsonContent);

        }
        $('.js-quiz-progress').html(html);

        if (_log) console.log('questions', questions);

    };


	/**
	 * Load question template
	 * @param {*} index 
	 */
    var loadQuestion = function (index) {
        if (_log) console.log('loadQuestion()', index);

        $('.js-quiz-response').html('');
        $('.js-quiz-load-question').html('');
        if (!$('.js-quiz-response').hasClass('hidden')) $('.js-quiz-response').addClass('hidden');
        if (!$('.js-quiz-response').hasClass('hidden')) $('.js-quiz-description').addClass('hidden');

        var question = questions[index];
        var isLast = ((questionCurrentIndex + 1) == maxQuestions) ? true : false;
        var compiledTemplate = Template7.compile(questionTemplate);
        var description = question.description.replace('JS-LOCURL', question.url);

        var jsonContent = {
            description: description,
            isLast: isLast,
            location: question.location,
            image: question.image,
            answer: question.answer,
            answers: question.answers,
            url: question.url
        };
        //if (_log) console.log('jsonContent:', jsonContent);

        var html = compiledTemplate(jsonContent);

        $('.js-quiz-load-question').html(html);
        if ($('.js-quiz-load-question').hasClass('hidden')) $('.js-quiz-load-question').removeClass('hidden');
        if ($('.js-quiz-progress').hasClass('hidden')) $('.js-quiz-progress').removeClass('hidden');
        if ($('.js-quiz-rules').hasClass('hidden')) $('.js-quiz-rules').removeClass('hidden');
        $('.js-quiz-choice').removeClass('hidden');
    };



	/**
	 * Check answer, update stage
	 * @param {*} answered 
	 * @param {*} answer 
	 */
    var checkAnswer = function (answered, answer) {
        answer = JSON.parse(answer);
        if (_log) console.group('checkAnswer()');
        if (_log) console.log('answered:', answered);
        if (_log) console.log('answer:', answer);

        var responseMessage = '';
        var random = 0;

        if(answered == answer){
            responseMessage = responseCorrect[random];
            correctAnswers++;
        } else {
            responseMessage = responseIncorrect[random];
        }

        if (_log) console.log('responseMessage', responseMessage);

        $('.js-quiz-response').html(responseMessage);
        $('.js-quiz-progress-mark-' + questionCurrentIndex).addClass("complete").find('sr-only').append(" complete");
        $('.js-quiz-response').removeClass('hidden');
        $('.js-quiz-description').removeClass('hidden');
        $('.js-quiz-next-question').removeClass('hidden');
        $('.js-quiz-choice').addClass('hidden');

        if (_log) console.groupEnd();
    };


	/**
	 * Reload questions, clear out divs, reset vars
	 */
    var reloadQuestions = function () {
        $('.js-quiz-response').addClass('hidden');
        $('.js-quiz-description').addClass('hidden');
        $('.js-quiz-load-question').addClass('hidden');
        $('.js-quiz-progress').addClass('hidden');
        $('.js-quiz-next-question').addClass('hidden');
        $('.js-quiz-results-wrapper').addClass('hidden');
        $('.js-quiz-results-score').html('');
        $('.js-quiz-results-message').html('');
        $('.js-quiz-progress').find('.js-quiz-progress-mark').remove();

        questionCurrentIndex = 0;
        questions = [];
        correctAnswers = 0;

        processContent(holdData);
        loadQuestion(questionCurrentIndex);
    };



	/**
	 * Show results, hide questions
	 */
    var showResults = function () {
        var percCorrect = Math.ceil((correctAnswers / maxQuestions) * 100),
            percRange = 0;
        if (percCorrect == 100) {
            percRange = 100;
        } else if (percCorrect > 50) {
            percRange = 75;
        } else if (percCorrect > 25) {
            percRange = 50;
        } else {
            percRange = 25;
        }
        var message = resultsMessages['perc' + percRange];

        if (_log) console.log('percCorrect', percCorrect);
        if (_log) console.log('percRange', percRange);

        $('.js-quiz-results-score').html('');

        for (var i = 0; i <= correctAnswers; i++) {
            var perc = Math.ceil((i / maxQuestions) * 100);
            var number = i + 1;
            var delay = (number / 5) + "s";
            var hidden = true;
            if (i == (correctAnswers - 1)) {
                hidden = false;
            }
            $('.js-quiz-results-score').append("<span class='ani--scroll-up' style='animation-delay:" + delay + "' aria-hidden='" + hidden + "'>" + perc + "%</span>");
        }
        $('meta[name=tw_quizScore]').attr('content', percCorrect);
        $('.js-quiz-results-message').html(message);
        $('.js-quiz-results-wrapper').removeClass('hidden');
        $('.js-quiz-progress').addClass('hidden');
        $('.js-quiz-load-question').addClass('hidden');
        $('.js-quiz-rules').addClass('hidden');
    };


	/**
	 * Randomize array element order in-place. Using Durstenfeld shuffle algorithm.
	 */
    var shuffleArray = function (array) {
        //console.log('shuffleArray()');
        for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
        return array;
    };

    $(initializePage); //doc ready

    // return {
    // 	//
    // }
}());